import { Navigate, useNavigate } from "react-router-dom";
import { useModules } from "@/auth/ModulesContext";
import { BankConnectionsPage as BankConnectionsPageView } from "@/components/BankConnectionsPage";

export function BankConnectionsPage() {
  const { modules, hasModule } = useModules();
  const navigate = useNavigate();
  // Resolved, not optimistic: a client without banking lands on home rather than a page of 403s.
  if (modules === null) return null;
  if (!hasModule("banking")) return <Navigate to="/" replace />;
  return <BankConnectionsPageView onOpenAccount={(id) => navigate(`/organisation/bank-connections/accounts/${id}`)} />;
}
